const uuidv4 = require("uuid/v4");

import Vue from "vue";
import $i18n from "@/i18n";

export class Dialog {
  constructor(params) {
    this.title = params.title ? params.title : "";
    this.text = params.text ? params.text : "";
    this.type = params.type ? params.type : "alert";
    this.submitHide = params.submitHide ? params.submitHide : false;

    this.submitFn = params.submitFn ? params.submitFn : () => {};
    this.cancelFn = params.cancelFn ? params.cancelFn : () => {};
  }

  getSubmitButtonLabel() {
    return $i18n.t("general.ok");
  }

  getCancelButtonLabel() {
    return $i18n.t("general.cancel");
  }
}
